import { HttpResponse, makeRequest } from './index';
import { TodoResponse } from '@/types/types';

const endpoint = 'Todo';

export const getTodos = async (): Promise<HttpResponse<TodoResponse[]>> => {
	const result = await makeRequest<null, TodoResponse[]>(`${endpoint}`, null, 'get');
	return result;
};

export const createTodo = async (title: string): Promise<HttpResponse<TodoResponse[]>> => {
	const result = await makeRequest<string, TodoResponse[]>(`${endpoint}?title=${title}`, null, 'post');
	return result;
};

export const deleteTodo = async (id: string): Promise<HttpResponse<TodoResponse[]>> => {
	const result = await makeRequest<string, TodoResponse[]>(`${endpoint}?todoId=${id}`, null, 'delete');
	return result;
};

export const updateTodoDone = async (id: string, isDone: boolean): Promise<HttpResponse<TodoResponse[]>> => {
	const result = await makeRequest<string, TodoResponse[]>(`${endpoint}/done?todoId=${id}&isDone=${isDone}`, null, 'put');
	return result;
};

export const updateTodoTitle = async (id: string, title: string): Promise<HttpResponse<TodoResponse[]>> => {
	const result = await makeRequest<string, TodoResponse[]>(`${endpoint}/title?todoId=${id}&title=${title}`, null, 'put');
	return result;
};
